/* eslint-disable no-use-before-define */
export type IAuthenticationResult =
  SuccessAuthenticationResult | FailureAuthenticationResult | RedirectAuthenticationResult;

export interface SuccessAuthenticationResult {
  status: AuthenticationResultStatus.Success;
  state: any;
}

export interface FailureAuthenticationResult {
  status: AuthenticationResultStatus.Fail;
  message: string;
}

export interface RedirectAuthenticationResult {
  status: AuthenticationResultStatus.Redirect;
}

export enum AuthenticationResultStatus {
  Success,
  Redirect,
  Fail,
}

// Disable naming convention as these are defined by the JWT and may not follow the standards we normally use
/* eslint-disable @typescript-eslint/naming-convention */
export interface IUser {
  agencyNumber?: string;
  lender: string;
  firmName: string;

  client_id: string;
  clubHub: string;
  fcaNumber: string;
  frnNumber?: string;
  termsDisclaimerAccepted: string;
  marketingPreferencesSaved: string;
  crmSystemInformationSaved: string;
  role: string[];
  sso_user?: string;

  [claim: string]: unknown;
  auth_time?: number;
  nonce?: string;
  sid?: string;
  sub: string;
  name?: string;
  profile?: string;
  email?: string;
  updated_at?: number;
}
